<template>
	<div class="container-fluid">
		<div class="container">
			<form name="form" @submit.prevent>
				<div class="forgot-password-container row">
					<div class="forgot-password-wrap card col-md-5 m-auto">
						<div class="align-items-center py-5">
							<div class="row">
								<div class="col-md-9 mx-auto">
									<div class="forgot-password-content d-flex align-items-center justify-content-center">
										<img src="../assets/image/logo_login.png" style="height: inherit;">
									</div>
									<h3 class="text-center mb-4">BERJAYA FINANCE - RPK
										<br>
										<span class="text-center text-danger mb-3" v-if="envMode != null && envMode != ''">[{{envMode}}]</span>
									</h3>
								</div>
							</div>
							
							<div class="row mb-4" v-if="sentMessage == null && token == null">
								<div class="col-md-9 mx-auto">
									<InputText class="p-inputtext" type="text" maxlength="50" placeholder="Email Address" v-model="user.username" />
								</div>
							</div>
							
							<div class="row mb-4" v-if="sentMessage == null && token == null">
								<div class="col-md-9 d-flex mx-auto">
									<div class="col-md-12 d-grid shadow">
										<Button class="p-button-lg text-uppercase" @click="forgotPassword" :disabled="v$.$invalid || isLoading" label="Reset Password"/>
									</div>
									
									<TheLoading v-if="isLoading"></TheLoading>
								</div>
							</div>
							
							<div class="row mb-4" v-if="sentMessage == null && token != null">
								<div class="col-md-9 mx-auto">
									<TheLoading v-if="isLoading"></TheLoading>
								</div>
							</div>
							
							<div class="row mb-4" v-if="sentMessage != null">
								<div class="col-md-9 mx-auto">
									<div class="forgot-password-icon forgot-password-icon-sent d-flex align-items-center justify-content-center">
										<FontAwesomeIcon :icon="['fas', 'check']" />
									</div>
									<h6 class="text-center mb-4 forgot-password-sent-font">{{sentMessage}}</h6>
								</div>
							</div>
							
							<div class="row mb-4" v-if="sentErrorMessage != null">
								<div class="col-md-9 mx-auto">
									<div class="forgot-password-icon forgot-password-icon-error d-flex align-items-center justify-content-center">
										<FontAwesomeIcon :icon="['fas', 'xmark']" />
									</div>
									<h6 class="text-center mb-4 forgot-password-error-font">{{sentErrorMessage}}</h6>
								</div>
							</div>
							
							<div class="row mb-4">
								<div class="col-md-9 mx-auto text-center">
									<Button class="p-button-link" label="Back to Login" @click="back" />
								</div>
							</div>
						</div>
						
						<TheFooter :hideCompany="true"></TheFooter>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script lang="ts">
	import { defineComponent } from "vue";
	import { envMode } from "../../package.json";
	
	import { useRoute } from "vue-router"
	import loginApi from "@/api/login-api";
	
	import TheFooter from "@/components/TheFooter.vue";
	import TheLoading from "@/components/TheLoading.vue";
	
	import { useVuelidate } from "@vuelidate/core";
	import { required, email } from "@vuelidate/validators";
	
	export default defineComponent({
		components: {
			TheFooter,
			TheLoading,
		},
		data() {
			return {
				envMode: envMode,
				user: {username: null},
				token: useRoute().query.token,
				sentMessage: null,
				sentErrorMessage: null,
				isLoading: false
			}
		},
		mounted: function() {
			if (this.token != null) {
				this.isLoading = true;
				loginApi.resetPassword({
						token: this.token
					})
					.then((response: any) => {
						this.isLoading = false;
						this.sentMessage = response.message;
					})
					.catch(error => {
						this.isLoading = false;
						this.sentErrorMessage = error;
					})
			}
		},
		methods: {
			forgotPassword() {
				this.isLoading = true;
				loginApi.forgotPassword({
						user: this.user
					})
					.then((response: any) => {
						this.isLoading = false;
						this.sentMessage = response.message;
					})
					.catch(error => {
						this.isLoading = false;
						this.$toast.add({severity: "error", summary: "Error", detail: error, life: 6000});
					})
			},
			back() {
				this.$router.push("/login");
			}
		},
		setup() {
			return { v$: useVuelidate() }
		},
		validations() {
			return {
				user: {
					username: {
						required, email
					}
				}
			}
		}
	});
</script>